import { render, staticRenderFns } from "./RincianSaldo.vue?vue&type=template&id=df16703e"
import script from "./RincianSaldo.vue?vue&type=script&lang=js"
export * from "./RincianSaldo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports